module.exports = __webpack_public_path__ + "static/media/moengage_logo_a1b5ee3fe6-removebg-preview.5e39ae04.png";